import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import ComfirmationBox from './ConfirmationBox';
import { ButtonContainer, ModalBodyContainer, customStyles } from './css';
import request from '../../components/utils/request';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { getLocale } from '../../components/misc';

const locale = getLocale();
const {
  WLS: {
    SessionTimeout: { alertTitle, bodyMessage, buttonText }
  }
} = locale === 'en-US' ? EN : FR;

const SessionTimeout = ({ children }) => {
  const [isOpen, setOpen] = useState(false);

  const checkForToken = () => {
    request.get('/users/checkToken').then(response => {
      if (response && response.status === 200) {
        if (response.data && response.data.isExpired) {
          if (localStorage.getItem('accessToken') !== null) {
            setOpen(true);
          }
        }
      }
    });
  };

  const checkForTokenInterceptors = () => {
    if (localStorage.getItem('isExpired') === true) {
      if (localStorage.getItem('accessToken') !== null) {
        setOpen(true);
      }
    }
  };

  const handleLogin = () => {
    setOpen(false);
    localStorage.clear();
    window.location.pathname = '/';
  };

  useEffect(() => {
    let sessionInterval;
    if (localStorage.getItem('accessToken') !== null) {
      sessionInterval = setInterval(() => {
        checkForToken();
        checkForTokenInterceptors();
      }, 5000);
    } else {
      clearInterval(sessionInterval);
    }
  }, []);

  return (
    <>
      {children}
      <ComfirmationBox
        hideCloseButton
        open={isOpen}
        setOpen={setOpen}
        customStyles={customStyles}
        header={alertTitle}
      >
        <ModalBodyContainer>
          <text>{bodyMessage}</text>
          <ButtonContainer>
            <Button onClick={handleLogin}>{buttonText}</Button>
          </ButtonContainer>
        </ModalBodyContainer>
      </ComfirmationBox>
    </>
  );
};

SessionTimeout.propTypes = {
  children: PropTypes.node.isRequired
};

export default SessionTimeout;
